import { toWebp } from "@/utils/common";
import MobileSlider from "./mobileSlider";
import StatCard from "./StatCard";

type softwareProps = {
  data?: any;
  isMobile?: boolean;
};

const Numbers: React.FC<softwareProps> = ({ data  }) => {
  const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL ?? "";
  const stats =
    data?.cards?.map((card: any) => ({
      value: card?.title || "",
      label: card?.description || "",
      icon: toWebp(
        card?.image?.data?.attributes?.url
          ? baseUrl + card.image.data.attributes.url
          : "/images/about/flag.png" // fallback
      ),
      icon2: toWebp(
        card?.hover_image?.data?.attributes?.url
          ? baseUrl + card.hover_image.data.attributes.url
          : "" // fallback
      ),
    })) || [];

  // Insert an empty slot after first stat for spacing (desktop grid)
  const statsWithGap =
    stats.length > 0
      ? [stats[0], { isEmpty: true }, ...stats.slice(1)]
      : [];

  return (
    <section className="xl:py-[100px] md:py-[80px] py-[56px] bg-[linear-gradient(96.18deg,_#E6F5FF_0%,_#5AA7DF_100%)] relative">
      {/* Backgrounds */}
      <div className="bg-[linear-gradient(0deg,_rgba(255,_255,_255,_0.8),_rgba(255,_255,_255,_0.8))] absolute z-[1] top-0 left-0 inset-0"></div>
      <div className="bg-[url(/images/enterprise-bg.png)] bg-size-[60%] bg-no-repeat bg-left-top absolute z-[2] top-0 left-0 inset-0"></div>

      {/* Content */}
      <div className="container mx-auto px-4 text-center relative z-10">
        <div className="flex flex-col items-center justify-center mx-auto">
          {/* Desktop Grid */}
          <div className="sm:grid hidden md:grid-cols-12 gap-6 md:gap-[30px] items-start w-full mb-[0]">
            <div className="sm:text-left xl:col-span-8 md:col-span-8">
              <h2 className="text-heading-1 font-bold text-center text-primary-text md:text-left md:mb-[0] mb-[0] md:mt-[0]">
                {data?.title}
              </h2>
            </div>

            {statsWithGap?.map((stat: any, index: number) => (
              <div
                key={index}
                className="sm:text-left xl:col-span-4 md:col-span-4"
              >
                {"isEmpty" in stat ? (
                  <div className="h-full w-full bg-transparent"></div>
                ) : (
                  <StatCard
                    value={stat?.value}
                    label={stat?.label}
                    icon={stat?.icon}
                    icon2={stat?.icon2}
                    color={index % 2 === 0 ? "blue-100" : "green-100"}
                    colorText={
                      index % 2 === 0 ? "text-blue-500" : "text-green-500"
                    }
                    i={index + 1}
                  />
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Mobile Slider */}
        <div className="sm:hidden block overflow-hidden w-full">
          <h2 className="text-heading-1 font-bold text-center text-primary-text md:text-left md:mb-[0] mb-[32px] md:mt-[0]">
            {data?.title}
          </h2>

          <MobileSlider>
            {stats?.map((stat: any, index: number) => (
              <StatCard
                key={index}
                value={stat?.value}
                label={stat?.label}
                icon={stat?.icon}
                icon2={stat?.icon2}
                color={index === 0 ? "blue-100" : index % 2 === 1 ? "blue-100" : "green-100"}
                colorText={index === 0 ? "text-blue-500" : index % 2 === 1 ? "text-blue-500" : "text-green-500"}
                i={index}
              />
            ))}
          </MobileSlider>
        </div>
      </div>
    </section>
  );
}

export default Numbers;
